import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {shippingMethodsKeyToArrayOfShippingMethods} from './relationships';

let shippingMethods = {};


// let cmrDomains = {};

const defaults = {

};

const ShippingMethodStore = createStore({
  storeEventBaseKey: "shipping_methods",
  normalizr: shippingMethodsKeyToArrayOfShippingMethods,
  normalizrKey: "shippingMethods",
  getData(){
    return shippingMethods;
  },
  getDefaults(){
    return defaults;
  },
  getShippingMethods(){
    return shippingMethods;
  },
  getShippingMethod(id){
    return shippingMethods[id];
  }
});

window.ShippingMethodStore = ShippingMethodStore;
export default ShippingMethodStore;


// WEBPACK FOOTER //
// ./src/stores/ShippingMethodStore.js